module.exports = __webpack_public_path__ + "static/20import-341cb538c06042fdf256cc2fd67d10f7.png";